import { makeStyles, FormSection, DropdownSelect } from '@paintscout/ui'
import type { DropdownSelectOption } from '@paintscout/ui'
import React from 'react'

export interface CompanySelectorProps {
  value: DropdownSelectOption
  companies: DropdownSelectOption[]
  className?: string
  disabled?: boolean
  minimumSearchCharacters?: number
  loading?: boolean
  hideDivider?: boolean
  allowCreateOption?: boolean
  onChange?: (option: DropdownSelectOption) => any
  onMinimumSearchCharactersReached?: (searchFilter: string) => void
  hasUnselect?: boolean
}

const useStyles = makeStyles((_theme) => ({
  root: {
    width: '100%'
  }
}))

function CompanySelector(props: CompanySelectorProps) {
  const {
    disabled,
    companies = [],
    value,
    onChange,
    hasUnselect,
    minimumSearchCharacters,
    onMinimumSearchCharactersReached,
    loading,
    hideDivider,
    allowCreateOption = true
  } = props
  const classes = useStyles()

  return (
    <FormSection hideDivider={hideDivider} classes={{ root: classes.root }}>
      <DropdownSelect
        disabled={disabled}
        placeholder={{
          selectPlaceholder: 'Select a company',
          plural: 'companies'
        }}
        name="company"
        variant="single"
        label="Company"
        fullWidth={true}
        searchable={true}
        value={value}
        onChange={onChange}
        hasUnselect={hasUnselect}
        options={companies}
        loading={loading}
        minimumSearchCharacters={minimumSearchCharacters}
        onMinimumSearchCharactersReached={onMinimumSearchCharactersReached}
        noOptionsMessage={'No companies found'}
        onCreateOption={
          allowCreateOption
            ? (inputValue) => {
                onChange({ label: inputValue, value: inputValue })
              }
            : null
        }
      />
    </FormSection>
  )
}

export default CompanySelector
